import { Filter } from 'common/repositories/common.model';
import QueryFilter from 'components/common/query-filter/query-filter';
import Separator from 'components/common/separator';
import React from 'react';

interface Props {
  filters?: Filter[];
  completeName?: string[];
  isShowAllFilterCompleted?: boolean;
}

export default function useExtractCompleteCompactFilter(props: Props) {
  const { completeName = [], filters = [], isShowAllFilterCompleted } = props;

  const { compactFilters, completeFilters } = React.useMemo(() => {
    const result = filters.reduce(
      (prev, filter) => {
        const isComplete = completeName.find((item) => item === filter.name);
        if (isComplete) {
          prev.completeFilters.push(filter);
        } else {
          prev.compactFilters.push(filter);
        }
        return prev;
      },
      {
        completeFilters: [] as Filter[],
        compactFilters: [] as Filter[],
      },
    );

    return result;
  }, [completeName, filters]);

  const filterComponent = React.useMemo(() => {
    if (isShowAllFilterCompleted) {
      return <QueryFilter filters={filters} isCompact={false} />;
    }

    return filters.length ? (
      <>
        {!!completeFilters.length && (
          <>
            <QueryFilter filters={completeFilters} isCompact={false} />
            <Separator gap={16} />
          </>
        )}
        {!!compactFilters.length && <QueryFilter filters={compactFilters} />}
      </>
    ) : null;
  }, [compactFilters, completeFilters, filters, isShowAllFilterCompleted]);

  return {
    compactFilters,
    completeFilters,
    filterComponent,
  };
}
